<template>
  <div
    class="measurement-result-list-table-row"
    :class="{
      check: useCheckbox,
      first: index === 0,
      even: index % 2 !== 0
    }"
    @click="clickItem"
  >
    <div
      v-if="showCheckbox"
      class="cell"
      data-test="checkbox"
      :style="cellStyles.checkbox"
      :title="checkboxTitle"
    >
      <base-check-box
        data-test="base-check-box"
        :disabled="!canCheck"
        :is-checked="checkboxStatus.isChecked"
        @input="checkItem"
      />
    </div>
    <div class="cell" data-test="date-time" :style="cellStyles.dateTime">
      <span>{{ jaRunDateTime }}</span>
    </div>
    <div class="cell" data-test="category" :style="cellStyles.category">
      <span>{{ categoryName }}</span>
    </div>
    <div class="cell" data-test="instrument" :style="cellStyles.instrument">
      <span>{{ instrumentName }}</span>
    </div>
  </div>
</template>

<script>
import BaseCheckBox from '@/components/parts/atoms/BaseCheckBox'
import { toJaDateTime } from '@/utils/moment'

export default {
  name: 'MeasurementResultListTableRow',

  components: { BaseCheckBox },

  props: {
    cellStyles: { type: Object, default: () => {} },
    checkboxDescription: { type: String, default: '' },
    checkboxStatus: { type: Object, default: () => {} },
    index: { type: Number, default: 0 },
    isCheckLimit: { type: Boolean, default: false },
    measurementResult: { type: Object, default: () => {} },
    useCheckbox: { type: Boolean, default: false }
  },

  computed: {
    canCheck() {
      return this.checkboxStatus.isChecked || !this.isCheckLimit
    },
    categoryName() {
      const category = this.measurementResult.category
      return category.name
    },
    checkboxTitle() {
      return this.canCheck ? '' : this.checkboxDescription
    },
    instrumentName() {
      const instrument = this.measurementResult.instrument
      return instrument.name
    },
    jaRunDateTime() {
      const { date, time } = this.measurementResult
      return toJaDateTime(`${date}${time}`)
    },
    showCheckbox() {
      return this.useCheckbox && !!this.checkboxStatus
    }
  },

  methods: {
    checkItem(boolean) {
      this.$emit('check', {
        isChecked: boolean,
        measurementResultId: this.measurementResult.id
      })
    },
    clickItem() {
      if (this.useCheckbox) return
      this.$emit('click', this.measurementResult)
    }
  }
}
</script>

<style lang="scss" scoped>
.measurement-result-list-table-row {
  min-height: 55px; // この値を変える場合はMeasurementResultListTable.vueのminItemSize: 55 の値も変更する
  display: flex;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  border-top: 1px solid #{$light-grey};
  &.first {
    border-top: none;
  }
  &.even {
    background-color: #{$white_f7};
  }
  &:not(.check):hover {
    opacity: 0.8;
    cursor: pointer;
  }
  > .cell {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
  }
}
</style>
